import API from "../config/api.js";


export const BatchService = {

  
    //get products
    getProducts() {
        return API.get("/api/inventory/products");
    },

    //search batch
    getBatchList(search, page=1) {
        return API.get(`/api/batch/list/se=${search}`, {params: {page: page}} );
    },

    async getBatchDetails(id) {
        try {
          const response = await API.get(`/api/batch/info/${id}`);
          return response.data.data; // Return the specific batch details
        } catch (error) {
          console.error("Error fetching Batch details:", error);
          throw error;
        }
      },
   

    async createBatch(formData){

        try{
            const response = await API.post('/api/batch/create', formData);
            return response.data; 
          }catch (error) {
            console.error("Error creating Batch:", error);
            throw error; // Rethrow error to handle it in the component
          } 

    },

    async  updateBatch(formData,id){

        try {
            console.log('Updating Batch with data:', formData);
            const response = await API.put(`/api/batch/info/update/${id}`, formData);
            console.log('Response from API:', response);
            if (response.status === 200) {
              return response.data;
            } else {
              throw new Error('Unexpected response status: ' + response.status);
            }
          } catch (error) {
                console.error('Error updating Batch:', error);
            if (error.response) {
              console.error('API Response Error:', error.response.data);
            }
            throw error;
          }
    }
}